module.exports = __webpack_public_path__ + "static/media/Graduate and Entry-Level Hiring.0ed2cdd5.png";